import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { CustomSelectOption } from 'src/app/core/interfaces/custom-select-option';
import { PhysicalExaminationGroup } from 'src/app/core/models/physical-examination-group';
import { PhysicalExaminationGroupService } from 'src/app/core/services/general/physical-examination-group.service';

@Component({
  selector: 'app-physical-examination-group-input',
  templateUrl: './physical-examination-group-input.component.html',
  styleUrls: ['./physical-examination-group-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: PhysicalExaminationGroupInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: PhysicalExaminationGroupInputComponent,
    },
  ],
})
export class PhysicalExaminationGroupInputComponent {
  @Input()
  title = "Select Group...";

  @Input()
  isDisabled = false;

  public value?: string;
  public localValue?: CustomSelectOption;

  public physicalExaminationGroupsList: Array<CustomSelectOption> = [];

  constructor(
    private physicalExaminationGroupService: PhysicalExaminationGroupService,
  ) {
    this.physicalExaminationGroupService
      .all()
      .subscribe((res: Array<PhysicalExaminationGroup>) => {
        this.physicalExaminationGroupsList = res.map((el) => {
          return {
            name: `${el.name}`,
            value: el.uuid,
          }
        });
        this.writeValue(this.value);
      });
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val?: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.physicalExaminationGroupsList.filter((el) => el.value == val)[0];
    }
  }

  onValueChange(val?: CustomSelectOption) {
    this.value = val?.value;
    this.onChange(this.value);
    this.writeValue(this.value);
  }


  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
